import { getElementProxies } from './proxy-elements.config';
import { appendProxyScript, createProxyScript, createScriptId, } from './proxy-elements.utils';
/**
 * Get the proxy list from config.
 */
var elementProxyList = getElementProxies();
/**
 * Iterate the list of FLUID component proxies, generating a script for
 * each and adding to the head of the document.
 *
 * As this is included as a global script in FLUID, any application using
 * FLUID will also be able to use these proxy components directly without
 * having to load any other scripts.
 */
elementProxyList.forEach(function (proxyElement) {
    var esmScript = createProxyScript(proxyElement.esmSource, createScriptId(proxyElement.selector), true);
    appendProxyScript(esmScript);
});
